const chatStartClick = () => {
  const libertyChatModal = document.getElementById('liberty-webchat-iframe');
  const isOpen = libertyChatModal?.getBoundingClientRect().height == 650;

  if (libertyChatModal && !isOpen) {
    window.dataLayer.push({event: 'chat_start'});
  }
};

export default chatStartClick;
